document.addEventListener('DOMContentLoaded', function () {
  /**
   * Manage dropdowns
   */
  const dropdownTriggerBtns = document.querySelectorAll('.platform-dropdown-btn ');

  dropdownTriggerBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const dropdown = btn.nextElementSibling; // Selects the next sibling element, which is the dropdown menu
      if (dropdown && dropdown.classList.contains('platform-dropdown-menu')) {
        dropdown.classList.toggle('active');

        if (dropdown.classList.contains('active')) {
          dropdown.style.display = 'block';
        } else {
          dropdown.style.display = 'none';
        }
      }
    })
  });

  document.addEventListener('click', (e) => {
    /**
     * Close Toast
     */
    if (e.target.hasAttribute('platform-toast-close')) {
      e.preventDefault();
      e.stopPropagation();
      const toast = e.target.closest('.platform-toast-container');
      if (toast) {
        toast.style.display = 'none';
        toast.remove();
      }
    }

    /**
     * Close Modal on platform-modal click but not on modal-content click
     */

    if (e.target.classList.contains('platform-modal') && !e.target.classList.contains('platform-modal-content') || e.target.hasAttribute('platform-modal-close')) {
      e.preventDefault();
      e.stopPropagation();
      const modals = document.querySelectorAll('.platform-modal');
      if (modals) {
        modals.forEach(modal => {
          modal.style.display = 'none';
        });

        const backdrop = document.querySelector('.platform-modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.style.overflow = 'initial';
      }
    }

    /**
     * Close dropdown on outside click
     * If the clicked element is not the dropdown itself or the button that triggers the dropdown
     */

    if (!e.target.classList.contains('platform-dropdown-btn') && !e.target.classList.contains('platform-dropdown-menu')) {
      const dropdowns = document.querySelectorAll('.platform-dropdown-menu');
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('active');
        dropdown.style.display = 'none';
      });
    }
  });

  /**
   * Manage Modal
   */

  const modalTriggerBtns = document.querySelectorAll('[platform-modal-trigger]');

  const modalBackdrop = `<div class="platform-modal-backdrop"></div>`;

  modalTriggerBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const modalId = btn.getAttribute('platform-modal-trigger');
      const modal = document.querySelector(modalId);
      if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';

        document.body.appendChild(document.createRange().createContextualFragment(modalBackdrop));
      }
    })
  });
})


const modalBackdrop = `<div class="platform-modal-backdrop"></div>`;

export class Modal {

  constructor(element) {
    this.element = element;
  }

  open() {
    this.element.style.display = 'block';
    document.body.style.overflow = 'hidden';
    document.body.appendChild(document.createRange().createContextualFragment(modalBackdrop));
  }

  close() {
    this.element.style.display = 'none';
    document.body.style.overflow = 'initial';
    const backdrop = document.querySelector('.platform-modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  }
}